<template>
    <v-card
        class="mx-auto card-balance-info"
        :class="{ receiving }"
        :outlined="$vuetify.breakpoint.mdAndUp"
        :flat="$vuetify.breakpoint.smAndDown"
    >
        <v-card-text class="card-balance-info-text-group">
            <v-row no-gutters>
                <v-col class="d-none d-md-flex" cols="1">
                    <v-img class="icon-info" src="@/assets/icon-info.svg">
                    </v-img>
                </v-col>
                <v-col class="col-12 col-md-11">
                    <span class="card-balance-info-text"><slot></slot></span
                ></v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'info-section',
    props: {
        receiving: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.card-balance-info {
    background: transparent;
    border: none;
    @include break('md') {
        width: 308px;
        height: 82px;
        min-width: 308px;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        border: solid 1px rgba(151, 151, 151, 0.39);
    }

    .card-balance-info-text-group {
        color: #212843 !important;
        text-align: left;
        line-height: 1.4;

        padding: 0 20px;
        @include break('sm') {
            padding: 0 30px;
        }
        @include break('md') {
            padding: 10px;
        }

        .icon-info {
            width: 11px;
            height: 11px;
            margin: 5px;
        }
        .card-balance-info-text {
            font-size: 11px;
            line-height: 0.8;
        }
    }
    &.receiving {
        @include break('md') {
            height: 72px;
        }
    }
}
</style>
